import { render, staticRenderFns } from "./ArqContrato.vue?vue&type=template&id=1c546a61&scoped=true&"
import script from "./ArqContrato.vue?vue&type=script&lang=js&"
export * from "./ArqContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c546a61",
  null
  
)

export default component.exports